module.exports = __webpack_public_path__ + "img/PIN.eb49abc6.svg";